(function () {
  'use strict';

  // Rebuy's subtotal percentage rounds the combined discount. The installed
  // Shopify Function truncates each line's discount to whole cents instead.
  // Keep every price in this builder on the same basis as the actual basket.
  function install(widget) {
    if (!widget || String(widget.id) !== '290619' || widget.minetanLineRounding ||
        typeof widget.getBundleDiscountedSubtotal !== 'function' ||
        typeof widget.getBundleBuilderDiscountedPriceProduct !== 'function') return;
    var subtotal = widget.getBundleDiscountedSubtotal;
    var productPrice = widget.getBundleBuilderDiscountedPriceProduct;
    function eligible() {
      var data = widget.data, discount = data.eligible_discount;
      return window.Shopify && Shopify.currency && Shopify.currency.active === 'USD' &&
        data.config.discount.type === 'shopify_functions' && data.selected_purchase_type !== 'subscription' &&
        discount && discount.discount_type === 'percentage' &&
        Number(discount.discount_value) >= 0 && Number(discount.discount_value) <= 100;
    }
    function discounted(cents) {
      // The small epsilon avoids truncating an exact integer a second time
      // because of binary floating-point representation.
      return cents - Math.floor(cents * Number(widget.data.eligible_discount.discount_value) / 100 + 1e-8);
    }
    widget.getBundleBuilderDiscountedPriceProduct = function (product, price) {
      if (!eligible()) return productPrice.apply(this, arguments);
      return (discounted(Math.round(Number(price) * 100)) / 100).toFixed(2);
    };
    widget.getBundleDiscountedSubtotal = function (products, applyDiscount, subscription) {
      if (!applyDiscount || subscription || !eligible()) return subtotal.apply(this, arguments);
      var groups = {};
      (products || widget.data.products || []).forEach(function (product) {
        var variant = product.selected_variant;
        var properties = Object.keys(product.properties || {}).sort().map(function (key) { return [key, product.properties[key]]; });
        var key = JSON.stringify([variant.id, properties]);
        var cents = Math.round(Number(widget.bundleVariantPrice(product, variant, false, false)) * 100);
        groups[key] = (groups[key] || 0) + cents;
      });
      return Object.keys(groups).reduce(function (total, key) { return total + discounted(groups[key]); }, 0);
    };
    widget.minetanLineRounding = true;
    if (widget.View && widget.View.vue) widget.View.vue.$forceUpdate();
  }
  document.addEventListener('rebuy.beforeReady', function (event) { install(event.detail && event.detail.widget); });
  document.addEventListener('rebuy.ready', function (event) { install(event.detail && event.detail.widget); });
  if (window.Rebuy && Array.isArray(Rebuy.widgets)) Rebuy.widgets.forEach(install);
})();
